import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "text-h6" }
const _hoisted_2 = { class: "header-form" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, "Historial de Registro", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "historic-component-subtitle" }, "Datos de Creación", -1)
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-12 col-md-6" }
const _hoisted_7 = { class: "col-12 col-md-6" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "historic-component-subtitle" }, "Datos última modificación", -1)
const _hoisted_9 = { class: "row" }
const _hoisted_10 = {
  key: 0,
  class: "col-12"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", null, "No existen datos de actualización", -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  key: 1,
  class: "col-12 col-md-6"
}
const _hoisted_14 = {
  key: 2,
  class: "col-12 col-md-6"
}
const _hoisted_15 = {
  key: 0,
  class: "row"
}
const _hoisted_16 = { class: "col-12 col-md q-pa-sm historic-component-container" }
const _hoisted_17 = { class: "col-12 col-md q-pa-sm" }
const _hoisted_18 = { class: "col-12 col-md q-pa-sm" }
const _hoisted_19 = { class: "col-12 col-md q-pa-sm" }
const _hoisted_20 = { class: "col-12 col-md" }
const _hoisted_21 = {
  key: 1,
  class: "row"
}
const _hoisted_22 = { class: "col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_toggle = _resolveComponent("q-toggle")!
  const _component_DatePickerComponent = _resolveComponent("DatePickerComponent")!
  const _component_AdministratorAutocompleteComponent = _resolveComponent("AdministratorAutocompleteComponent")!
  const _component_TypeOperationSelectComponent = _resolveComponent("TypeOperationSelectComponent")!
  const _component_filter_button_component = _resolveComponent("filter-button-component")!
  const _component_table_component = _resolveComponent("table-component")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    modelValue: _ctx.toggleHistoricDialog,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.toggleHistoricDialog) = $event)),
    persistent: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, {
        class: "historic-component",
        style: {"width":"800px","max-width":"80vw"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, { class: "historic-component-section" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _hoisted_3,
                  _createElementVNode("div", null, [
                    _createVNode(_component_q_btn, {
                      class: "q-mr-sm historic-component-btn",
                      color: "primary",
                      icon: "download",
                      onClick: _ctx.onExportHistoric
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_tooltip, null, {
                          default: _withCtx(() => [
                            _createTextVNode("Exportar Historial")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                      class: "historic-component-btn",
                      color: "negative",
                      icon: "close"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_tooltip, null, {
                          default: _withCtx(() => [
                            _createTextVNode("Cerrar ventana")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })), [
                      [_directive_close_popup]
                    ])
                  ])
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, { class: "historic-component-section container" }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _hoisted_4,
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("p", null, _toDisplayString(_ctx.historic_data.admin_created), 1)
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("p", null, _toDisplayString(_ctx.date_created), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_8,
                _createElementVNode("div", _hoisted_9, [
                  (!_ctx.historic_data.admin_updated)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12))
                    : _createCommentVNode("", true),
                  (_ctx.historic_data.admin_updated)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _createElementVNode("p", null, _toDisplayString(_ctx.historic_data.admin_updated), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.historic_data.admin_updated)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _createElementVNode("p", null, _toDisplayString(_ctx.date_updated), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createVNode(_component_q_btn, {
                flat: "",
                color: "primary",
                label: _ctx.label_details,
                onClick: _ctx.toggleDetails
              }, null, 8, ["label", "onClick"]),
              (_ctx.toggle_details)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(_component_q_toggle, {
                        class: "historic-component-toggle",
                        modelValue: _ctx.is_historic,
                        "onUpdate:modelValue": [
                          _cache[0] || (_cache[0] = ($event: any) => ((_ctx.is_historic) = $event)),
                          _ctx.toggleHistoricDetails
                        ],
                        color: "primary",
                        label: "Histórico",
                        dense: true
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createVNode(_component_DatePickerComponent, {
                        disable: _ctx.is_historic,
                        clear: _ctx.resetData,
                        onDate_selected: _ctx.selectDate
                      }, null, 8, ["disable", "clear", "onDate_selected"])
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(_component_AdministratorAutocompleteComponent, {
                        disable: _ctx.is_historic,
                        clear: _ctx.resetData,
                        onAdministrator_selected: _ctx.administratorSelected
                      }, null, 8, ["disable", "clear", "onAdministrator_selected"])
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createVNode(_component_TypeOperationSelectComponent, {
                        disable: _ctx.is_historic,
                        clear: _ctx.resetData,
                        onType_operation_selected: _ctx.typeOperationSelected
                      }, null, 8, ["disable", "clear", "onType_operation_selected"])
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _createVNode(_component_filter_button_component, {
                        onOnSearch: _ctx.onSearch,
                        onOnReset: _ctx.onReset,
                        enableOrderBtn: false
                      }, null, 8, ["onOnSearch", "onOnReset"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.toggle_details)
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _createVNode(_component_table_component, {
                        loading: _ctx.loading,
                        tableStyle: _ctx.TableStyle.SUBSERVICE,
                        enableVirtualScroll: true,
                        enablePagination: false
                      }, null, 8, ["loading", "tableStyle"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_q_card_actions, { align: "center" }, {
                default: _withCtx(() => [
                  _withDirectives(_createVNode(_component_q_btn, {
                    label: "Cancelar",
                    color: "negative",
                    onClick: _ctx.cancelOption
                  }, null, 8, ["onClick"]), [
                    [_directive_close_popup]
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}